import { DEFAULT_DESIGN_LIST_LIMIT } from '@repo/api-contracts';

/** 내 디자인 목록 캐시 키 — 마이페이지 홈과 내 디자인 화면이 첫 페이지를 함께 쓰고, 삭제·복제 뒤 무효화할 때도 쓴다. */
export const MY_DESIGNS_QUERY_KEY = ['my-designs', DEFAULT_DESIGN_LIST_LIMIT] as const;
